var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_35",
    "data-name": "Repeat Grid 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-280 -61)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    x2: 36,
    transform: "translate(282 63)",
    fill: "none",
    stroke: "#106da0",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-280 -47)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_109-2",
    "data-name": "Line 109",
    x2: 36,
    transform: "translate(282 63)",
    fill: "none",
    stroke: "#106da0",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-280 -33)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_109-3",
    "data-name": "Line 109",
    x2: 36,
    transform: "translate(282 63)",
    fill: "none",
    stroke: "#106da0",
    strokeLinecap: "round",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBurgerMenu);
export default __webpack_public_path__ + "static/media/mobile-burger-menu.2fa46983dada1a8276d967b2ebbd0de6.svg";
export { ForwardRef as ReactComponent };